import { lazy } from 'react'
import BlankLayout from '../../@core/layouts/BlankLayout'
import GuestGuard  from '../guards/GuestGuard'

const Login       = lazy(() => import('../../views/Authentication/Login'))
const SsoCallback = lazy(() => import('../../views/Authentication/SsoCallback'))

const AuthenticationRoutes = [
  { path: '/login',        element: <BlankLayout><GuestGuard component={Login}       restricted={true}  /></BlankLayout> },
  { path: '/sso/callback', element: <BlankLayout><GuestGuard component={SsoCallback} restricted={false} /></BlankLayout> },
]

export default AuthenticationRoutes